export default {
  SERVICES: "services",
  FAIRE_MES_COURSES: "Faire mes courses",
  MEA_1: "Menu_Encarts_1",
  MEA_2: "Menu_Encarts_2",
  MEA_3: "Menu_Encarts_3",
  BRANDS: "MENU_Marques",
  CATEGORIES_PER_LINE: 10,
  HEADER_RECETTES: "Header_Recettes"

}
